"use client";

// Client-side hooks for Next.js Chipi SDK
// These are re-exported from @chipi-stack/chipi-react for convenience
// This file is marked as 'use client' to ensure it only runs on the client

export {
  // Context hook
  useChipiContext,

  // Wallet hooks
  useCreateWallet,
  useGetWallet,

  // Transaction hooks
  useApprove,
  useTransfer,

  // SKU hooks
  useGetSkus,


  // SKU Transaction hooks
  useCreateSkuTransaction,
  useGetSkuTransactionById,
  

  // Specialized transaction hooks
  useStakeVesuUsdc,
  useWithdrawVesuUsdc,
  useCallAnyContract,

  // Record send transaction hook
  useRecordSendTransaction,

  // Token balance hook
  useGetTokenBalance,
} from "@chipi-stack/chipi-react";
